import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ManageInnovaService } from '../../manage-project/project-data/manage-innova.service';
import { IFLInnovacio, IFLSotware } from './innovacio.interfaces';

@Component({
  selector: 'dialog-innovacio',
  templateUrl: 'dialog.component.innovacio.html',
  styleUrls: ['dialog.component.innovacio.css'],
  providers: [ManageInnovaService]
})

export class DialogInnovacio {
  public documentInno: IFLInnovacio = {'id': 0, 'codi': '','innova_metodologic': '','innova_dev_informatic': '','percent_finan_intern': '','percent_dev_metodologic': '',
    'percent_dev_informatic': '','obs_innova_metodologic': '','obs_innova_dev_informatic': '',
    'tipus': ''};
  public documentSoft: IFLSotware = {'id': 0, 'codi': '','front_end': '','back_end': '','desktop': '','observacions': '',
    'tipus': '','t1_1': '','t1_2': '','t2_1': '','t2_2': '','t3_1': '','t3_2': '','t4_1': '','t4_2': '','t5_1': '','t5_2': '',
    't6_1': '','t6_2': '','t7_1': '','t7_2': '','t8_1': '','t8_2': '','t9_1': '','t9_2': ''};

  public editInnovacioData = Object.assign(this.documentInno);
  public editSoftData = Object.assign(this.documentSoft);
   
  public possibleTipus = [];
  public possibleTipusInnoMet = [];
  public possibleDevInf = [];
  public possibleFrontEnd = [];
  public possibleBackEnd = [];
  public possibleDesktop = [];

  constructor(public translate: TranslateService, public languageService: LanguageService, protected manageInnovaService: ManageInnovaService, public dialogRef: MatDialogRef<DialogInnovacio>, @Inject(MAT_DIALOG_DATA) public data: any){
    this.manageInnovaService.get(data).subscribe(dades => {
      this.editInnovacioData = dades.innova?dades.innova: this.documentInno; 
      this.editSoftData = dades.soft?dades.soft:this.documentSoft;
      this.manageInnovaService.getAutocomplete("projTipInno").subscribe(resul => this.possibleTipus = resul, err => console.log(err));
      this.manageInnovaService.getAutocomplete("projMetInno").subscribe(resul => this.possibleTipusInnoMet = resul, err => console.log(err));
      this.manageInnovaService.getAutocomplete("projDevInno").subscribe(resul => this.possibleDevInf = resul, err => console.log(err));
      this.manageInnovaService.getAutocomplete("projSoftInno_fe").subscribe(resul => this.possibleFrontEnd = resul, err => console.log(err));
      this.manageInnovaService.getAutocomplete("projSoftInno_be").subscribe(resul => this.possibleBackEnd = resul, err => console.log(err));
      this.manageInnovaService.getAutocomplete("projSoftInno_de").subscribe(resul => this.possibleDesktop = resul, err => console.log(err));
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close({inno: this.editInnovacioData, soft: this.editSoftData});
  }

  ngOnInit(){ }

}